import { Checkbox, FormControlLabel, FormGroup, Stack } from "@mui/material";
import { EditorActionModule } from "../../../types/actionModule/editor/actionModuleEditorTypes";
import SelectGroupsList from "../../../components/groups/SelectGroupsList";
import { useTranslation } from "react-i18next";

interface Props {
    value: EditorActionModule | null;
    companyId?: number;
    onChanged: (value: EditorActionModule) => void;
}

export function ActionModuleAssignmentTab(props: Props) {
    const { t } = useTranslation();
    const value = props.value;

    if (!value) {
        return <></>;
    }

    return <Stack sx={{p: 2, height: "100%", minHeight: 0}}>
        <FormGroup>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={value.isCompanyWideAssigned}
                        onChange={(e) => props.onChanged({
                            ...value,
                            isCompanyWideAssigned: e.target.checked,
                        })} />
                }
                label={t("actionModuleEditor.tabModuleAssignment.isCompanyWideAssigned")}
            />
        </FormGroup>
        <SelectGroupsList
            companyId={props.companyId}
            value={value.assignedGroupIds} onChange={(ids) => props.onChanged({
                ...value,
                assignedGroupIds: ids,
            })} />
    </Stack>
}